/* Point d'entrée de l'application Factumis (app.factumis.fr).
   Monte React en StrictMode avec BrowserRouter, puis délègue tout le
   routage à <App />. Les feuilles de style globales sont importées ici
   dans l'ordre : polices → tokens CSS → styles applicatifs. */
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './styles/fonts.css';
import './styles/tokens.css';
import './styles/app.css';
import { App } from './App';

const root = document.getElementById('root');
if (!root) throw new Error('#root introuvable');

createRoot(root).render(
  <StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StrictMode>,
);
